import {
  Button,
  Card,
  CardContent,
  Container,
  Stack,
  Typography,
} from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { exitAssessment } from "../../lib/assessmentExit";

export function TestCompletedPage() {
  const goToBackpack = () => {
    exitAssessment();
  };

  return (
    <Container
      sx={{
        py: 6,
        justifyItems: "center",
        height: "100vh",
        alignContent: "center",
      }}
    >
      <Card
        sx={(theme) => ({
          border: `2px solid ${theme.palette.primary.main}`,
          borderRadius: 2,
          maxWidth: "680px",
          backgroundColor: theme.palette.background.default,
        })}
      >
        <CardContent sx={{ py: 8 }}>
          <Stack spacing={2} alignItems="center">
            <CheckCircleRoundedIcon
              sx={{ fontSize: 64, color: "primary.main" }}
            />
            <Typography
              variant="h4"
              sx={{ color: "primary.main", fontWeight: 700 }}
            >
              Test Complete!
            </Typography>
            <Typography>
              Your answers have been submitted successfully.
            </Typography>
            <Button onClick={goToBackpack} sx={{ mt: 2 }}>
              Back to Dashboard
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Container>
  );
}
